import { AsbisLogo, AsbcLogo, BreezyLogo, BreezyLogoLight } from './icons';
import { type Logos } from '~/domains/core';

export const logoConfig: Logos = {
  ASBIS: {
    dark: AsbisLogo,
    light: AsbisLogo,
  },
  ASBC: {
    dark: AsbcLogo,
    light: AsbcLogo,
  },
  BREEZY: {
    dark: BreezyLogo,
    light: BreezyLogoLight,
  },
};
